import * as React from 'react';
import './Splash.scss';

import { UserService } from 'services/ApiService';
import { Redirect } from 'react-router-dom';

import QueryString from 'query-string';

import Loader from 'components/Loader';
import { CLAIMS_PATH } from 'helpers/routes';

const LCBO_LOGO = require('./lcbo.png');
const ICON = require('./icon.png');

export default class Splash extends React.Component<{}, {loading: boolean, signedIn: boolean}> {
  formRefs: {email: HTMLInputElement | null, password: HTMLInputElement | null} = {email: null, password: null};

  constructor(props: {}) {
    super(props);
    this.state = {
      loading: true,
      signedIn: false
    };
  }

  signIn = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    this.setState({ loading: true });
    const email = this.formRefs.email!!.value;
    const password = this.formRefs.password!!.value;

    UserService.login({ email: email, password: password })
    .then((data) => {
      this.setState({ loading: false, signedIn: true });
    })
    .catch((err) => {
      this.setState({ loading: false });
    });
  }

  componentDidMount() {
    UserService.tryAuth().then(signedIn => {
      this.setState({ loading: false, signedIn });
    });
  }

  render() {
    return this.state.signedIn ? <Redirect to={QueryString.parse(location.search).redirect || CLAIMS_PATH} /> : (
      <div className="splash">
        <div className="top">
          <div className="topLeft">
            <img className="logo" src={LCBO_LOGO} />
            <div className="text">
              LCO Claims Application
            </div>
          </div>
          <img className="icon" src={ICON} />
        </div>

        <div className="bottom">
          <form onSubmit={this.signIn} style={this.state.loading ? { display: 'none' } : {}}>
            <input
              type="email"
              ref={el => this.formRefs.email = el}
              placeholder="Email"
              autoComplete="user-email"
            />
            <input
              type="password"
              ref={el => this.formRefs.password = el}
              placeholder="Password"
              autoComplete="new-password"
            />
            <button>Login</button>
          </form>
          {(this.state.loading) ? <Loader /> : null}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/Splash/index.tsx